import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  button: {
    outline: 0,
    borderRadius: 90,
    cursor: "pointer",
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 42,
    paddingRight: 42,
    fontFamily: "SF Pro Display",
    textTransform: "none",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.1,
    boxSizing: "border-box",
    display: "flex",
    gap: 5,
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 450px)": {
      paddingLeft: 28,
      paddingRight: 28,
    }
  },
  buttonsm: {
    width: 142,
    height: 39
  },
  buttonmd: {
    width: 150,
    height: 45
  },
  buttonlg: {
    width: 167,
    height: 54
  },
  buttonfluid: {
    height: 54
  },
  buttonnormal: {
    height: 44
  },
  buttonfull: {
    width: "100%",
    height: 54
  },
  primary: {
    backgroundColor: "white",
    border: `0px solid white`
  },
  secondary: {
    backgroundColor: "#33D49D",
    border: `0px solid #33D49D`
  },
  primaryOutline: {
    backgroundColor: "none",
    border: `1.5px solid rgba(4, 5, 5, 0.24)`
  },
  secondaryOutline: {
    backgroundColor: "none",
    border: `1.5px solid white`
  },
  warning: {
    backgroundColor: "red",
    border: `0px solid `
  },
  warningOutline: {
    backgroundColor: "none",
    border: `1.5px solid red`
  },
  successOutline: {
    background: "none",
    border: "1.5px solid #036B26"
  },
  whiteOutline: {
    background: "none",
    border: "1.5px solid #ffffffff"
  },
  dangerOutline: {
    backgroundColor: "white",
    border: "1.5px solid #CB1A14"
  },
  default: {
    backgroundColor: "black",
    border: "1.5px solid black"
  },
  success: {
    background: "#036B26",
    border: "1.5px solid #036B26"
  },
  btnsuccess: {
    color: "white",
    background: "none",
    border: "1px solid white"
  },
  btnGreen: {
    color: "black",
    background: "rgba(51, 212, 157, 1)",
  },
  btnblackOutline: {
    color: "black",
    background: "none",
    border: "1px solid rgba(4, 5, 5, 0.24)"
  },
  danger: {
    backgroundColor: "#CB1A14",
    border: "0px solid #CB1A14"
  },
  btnwhite: {
    color: "white"
  },
  btnsecondary: {
    color: "#344054"
  },
  btnblack: {
    color: "black"
  },
  btndanger: {
    color: "#CB1A14"
  },
  btnfontprimary: {
    color: "rgba(0, 53, 26, 1)"
  },
  btnfontsecondary: {
    color: "white"
  },
  loader: {
    height: 20
  }
}));
